import React, { useEffect, useState } from 'react';
import { Bar, Line, Pie, PolarArea } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement, RadialLinearScale } from 'chart.js';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { Col, Container, Row } from 'react-bootstrap';


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, PointElement, LineElement, RadialLinearScale);

const Dashboard = () => {
    const [salesData, setSalesData] = useState({
        labels: [],
        datasets: [],
    });

    const [salesDataDay, setSalesDataDay] = useState({
        labels: [],
        datasets: [],
    });

    const [salesDataItemsFood, setSalesDataItemsFood] = useState({
        labels: [],
        datasets: [],
    });

    const [salesDataCategory, setSalesDataCategory] = useState({
        labels: [],
        datasets: [],
    });

    const [expensesDataCategory, setExpensesDataCategory] = useState({
        labels: [],
        datasets: [],
    });

    const fechaActual = new Date();
    const year = fechaActual.getFullYear().toString();
    const month = fechaActual.getMonth();
    const [SelectedMonth, setSelectedMonth] = useState((month + 1).toString());
    const [SelectedYear, setSelectedYear] = useState(year);

    useEffect(() => {

        const fetchSalesData = async () => {
            const dataSale = await dotoniwoofApi.get(`/sale.php/sale-report?year=${SelectedYear}`);
            const dataExpense = await dotoniwoofApi.get(`/expense.php/expense-report?year=${SelectedYear}`);
            setSalesData({
                labels: dataSale.data.message[0].months,
                datasets: [
                    {
                        label: 'Ventas ($)',
                        data: dataSale.data.message[0].sales,
                        backgroundColor: 'rgba(10, 129, 46, 0.4)',
                        borderColor: 'rgb(23, 223, 116)',
                        borderWidth: 1,
                    },
                    {
                        label: 'Gastos ($)',
                        data: dataExpense.data.message[0].expenses,
                        backgroundColor: 'rgba(206, 88, 10, 0.4)',
                        borderColor: 'rgb(255, 38, 38)',
                        borderWidth: 1,
                    },
                ],
            });
        };
        fetchSalesData();
    }, [SelectedYear]);

    useEffect(() => {

        const fetchSalesDataCategory = async () => {
            const data = await dotoniwoofApi.get(`/sale.php/sale-report-category?year=${SelectedYear}`);
            setSalesDataCategory({
                labels: data.data.message[0].categories,
                datasets: [{
                    label: ' Ventas $',
                    data: data.data.message[0].sales,
                    backgroundColor: data.data.message[0].rgb,
                    hoverOffset: 4
                }]
            });
        };
        fetchSalesDataCategory();
    }, [SelectedYear]);

    useEffect(() => {

        const fetchExpensesDataCategory = async () => {
            const data = await dotoniwoofApi.get(`/expense.php/expense-report-category?month=${SelectedMonth}`);
            setExpensesDataCategory({
                labels: data.data.message[0].categories,
                datasets: [{
                    label: ' Gastos $',
                    data: data.data.message[0].expenses,
                    backgroundColor: data.data.message[0].rgb,
                    hoverOffset: 4
                }]
            });
        };
        fetchExpensesDataCategory();
    }, [SelectedMonth]);



    useEffect(() => {
        const fetchSalesDataDay = async () => {
            const dataSale = await dotoniwoofApi.get(`/sale.php/sale-report-day?month=${SelectedMonth}`);
            const dataExpense = await dotoniwoofApi.get(`/expense.php/expense-report-day?month=${SelectedMonth}`);
            setSalesDataDay({
                labels: dataSale.data.message[0].days,
                datasets: [
                    {
                        label: 'Ventas ($)',
                        data: dataSale.data.message[0].sales,
                        backgroundColor: 'rgba(24, 16, 247, 0.4)',
                        borderColor: 'rgb(11, 196, 233)',
                        borderWidth: 1,
                    },
                    {
                        label: 'Gastos ($)',
                        data: dataExpense.data.message[0].expenses,
                        backgroundColor: 'rgba(175, 0, 0, 0.4)',
                        borderColor: 'rgb(255, 43, 43)',
                        borderWidth: 1,
                    },
                ],
            });
        };
        fetchSalesDataDay();
    }, [SelectedMonth])

    useEffect(() => {
        const fetchSalesDataItemsFood = async () => {
            const data = await dotoniwoofApi.get(`/sale.php/sale-report-item-food?month=${SelectedMonth}`);
            setSalesDataItemsFood({
                labels: data.data.message[0].products,
                datasets: [
                    {
                        label: 'Ventas ($)',
                        data: data.data.message[0].sales,
                        backgroundColor: 'rgba(247 166 16 / 0.4)',
                        borderColor: 'rgb(233 118 11)',
                        borderWidth: 1,
                    },
                ],
            });
        };
        fetchSalesDataItemsFood();
    }, [SelectedMonth])

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Ventas por mes',
            },
        },
    };
    const optionsBarHorizontal = {
        indexAxis: 'y',
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Ventas por mes',
            },
        },
    };
    const optionsPie = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Ventas por categoria',
            },
        },
    };
    return (
        <>
            <Container style={{ padding: "20px", color: "white"}} fluid>
                <Row>
                    <Col>
                        <div style={{ width: '90%', margin: '0 auto' }}>
                            <h2>Ventas por mes</h2>
                            <Bar data={salesData} options={options} />
                            <label style={{ padding: "5px" }}>Año:</label>
                            <select onChange={(e) => setSelectedYear(e.target.value)}>
                                <option value={year}>Año actual</option>
                                <option value="2025">2025</option>
                                <option value="2024">2024</option>
                            </select>
                        </div>
                    </Col>
                    <Col>
                        <div style={{ width: '90%', margin: '0 auto' }}>
                            <h2>Ventas por dias</h2>
                            <Bar data={salesDataDay} options={options} />
                            <label style={{ padding: "5px" }}>Mes:</label>
                            <select onChange={(e) => setSelectedMonth(e.target.value)}>
                                <option value={(month + 1).toString()}>Mes actual</option>
                                <option value="01">Enero</option>
                                <option value="02">Febrero</option>
                                <option value="03">Marzo</option>
                                <option value="04">Abril</option>
                                <option value="05">Mayo</option>
                                <option value="06">Junio</option>
                                <option value="07">Julio</option>
                                <option value="08">Agosto</option>
                                <option value="09">Septiembre</option>
                                <option value="10">Octubre</option>
                                <option value="11">Noviembre</option>
                                <option value="12">Diciembre</option>
                            </select>
                        </div>
                    </Col>
                </Row>
                <Row>

                    <Col>
                        <div style={{ width: '90%', margin: '0 auto' }}>
                            <h2>Ventas por mes</h2>
                            <Line data={salesData} options={options} />
                        </div>
                    </Col>
                    <Col>
                        <div style={{ width: '90%', margin: '0 auto' }}>
                            <h2>Ventas por mes</h2>
                            <Line data={salesDataDay} options={options} />
                        </div>
                    </Col>


                </Row>
                <Row>

                    <Col>
                        <div style={{ width: '90%', margin: '0 auto' }}>
                            <h2>Ventas por comida al granel</h2>
                            <Bar data={salesDataItemsFood} options={optionsBarHorizontal} />
                        </div>
                    </Col>


                </Row>

                <Row>
                    <Col>
                        <div style={{ width: '90%', margin: '0 auto' }}>
                            <h2>Ventas por Categoria</h2>
                            <Bar data={salesDataCategory} options={optionsBarHorizontal} />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div style={{ width: '90%', margin: '0 auto' }}>
                            <h2>Gastos por Categoria</h2>
                            <Bar data={expensesDataCategory} options={optionsBarHorizontal} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Dashboard;
